import type { ReactNode } from 'react';
import { PendingDot } from './pending-dot';

type RecordTitleProps = {
  readonly children: ReactNode;
  readonly pending: boolean;
  readonly struck?: boolean;
};

export function RecordTitle({ children, pending, struck }: RecordTitleProps) {
  return (
    <span className="flex items-center gap-2">
      <span className={struck ? 'truncate line-through' : 'truncate'}>{children}</span>
      <PendingDot pending={pending} />
    </span>
  );
}
